import React from "react";
/** @jsx jsx */
import { Global, jsx, css } from "@emotion/core";
import GoogleFontLoader from "react-google-font-loader";

import Header from "./Header";
import Main from "./Main";
import Footer from "./Footer";

const container = css`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  height: 100vh;
`;

class App extends React.Component {
  render() {
    return (
      <>
        <GoogleFontLoader fonts={[{ font: "Merienda One", weights: [400] }]} />
        <Global
          styles={css`
            body {
              background: url("/assets/theone3.jpg") top center no-repeat;
              background-size: cover;
              background-attachment: fixed;
              background-color: #000;
              font-family: "Merienda One", serif;
            }

            body,
            a {
              color: #ff3333;
              transition: color ease-in-out 0.5s;
              text-decoration: none;
              text-shadow: 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000, -1px -1px 0 #000;
            }
            
            a:hover {
              color: #ff6666; 
            }

            .active {
              color: red;
            }

            h2 {
              font-size: 0.875rem;
              font-weight: normal;
              text-transform: uppercase;
              text-align: center;
            }

            h3 {
              font-size: 0.75rem;
              font-weight: normal;
            }

            ul {
              list-style: none;
              margin: 0;
              padding: 0;
            }

            p {
              font-size: 0.75rem;
            }

            @media (max-width: 768px) {
              body {
                background-attachment: scroll;
              }

              h2 {
                font-size: 0.75rem;
              }

              h3 {
                font-size: 0.65rem;
              }

              p {
                font-size: 0.65rem;
              }
            }

            @media (max-width: 480px) {
              body {
                font-size: 14px;
              }

              h2 {
                font-size: 0.7rem;
              }

              h3 {
                font-size: 0.6rem;
              }

              p {
                font-size: 0.6rem;
              }
            }
          `}
        />
        <div css={container}>
          <Header />
          <Main />
          <Footer />
        </div>
      </>
    );
  }
}

export default App;
